import { createStore } from "redux";
// import reducers from './reducers';
import { composeWithDevTools } from "redux-devtools-extension";

import reducers from "./store/reducers";

const resumeStore = createStore(reducers, composeWithDevTools());

export default resumeStore;
